<template>
  <div style="padding: 20px">
    <el-form
      ref="ruleForm"
      label-width="200px"
      class="demo-ruleForm"
      :rules="rules"
      :model="ruleForm"
    >
      <el-form-item label="10min最大风速（m/s）" prop="maxWspd">
        <el-input
          v-model="ruleForm.maxWspd"
          :maxlength="10"
          oninput="value=value.replace(/[^\d.]/g,'')"
        ></el-input>
      </el-form-item>
      <el-form-item label="平均风速大于（m/s）" prop="wspd">
        <el-input v-model="ruleForm.wspd" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="风机间距-长轴" prop="longAxisDistance">
        <el-input
          v-model="ruleForm.longAxisDistance"
          :maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item label="风机间距-短轴" prop="shortAxisDistance">
        <el-input
          v-model="ruleForm.shortAxisDistance"
          :maxlength="10"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="长轴方位夹角（°）" prop="longAxisAngle">
        <el-input v-model="ruleForm.longAxisAngle" :maxlength="10"></el-input>
      </el-form-item> -->
      <el-form-item label="地形坡度小于（°）" prop="maxSlope">
        <el-input v-model="ruleForm.maxSlope" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="距边界距离（m）" prop="boundaryDistance">
        <el-input
          v-model="ruleForm.boundaryDistance"
          :maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="save" type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        landOrSea: '',
        maxSlope: '',
        maxWspd: '',
        boundaryDistance: '',
        wspd: '',
        //longAxisAngle: '',
        longAxisDistance: '',
        shortAxisDistance: ''
      },

      rules: {
        maxSlope: [
          { required: true, message: '请输入地形坡度', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ],
        maxWspd: [
          { required: true, message: '请输入最大风速', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ],
        boundaryDistance: [
          { required: true, message: '请输入距边界距离', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ],
        wspd: [
          { required: true, message: '请输入平均风速', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ],
        // longAxisAngle: [
        //   { required: true, message: '请输入长轴方位夹角', trigger: 'blur' },
        //   { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
        // ],
        longAxisDistance: [
          { required: true, message: '请输入风机间距-长轴', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ],
        shortAxisDistance: [
          { required: true, message: '请输入风机间距-短轴', trigger: 'blur' },
          {
            pattern: /^[0-9]+(\.?[0-9]+)?$/,
            message: '只能输入数字',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  async mounted() {
    await this.getWindfarmPlanDefaultCondition();
  },
  methods: {
    async getWindfarmPlanDefaultCondition() {
      const { data } = await this.$fetch(
        '/manage/station/getWindfarmPlanDefaultCondition',
        {
          module: 'manage'
        }
      );
      const {
        landOrSea,
        maxSlope,
        maxWspd,
        boundaryDistance,
        wspd,
        // longAxisAngle,
        longAxisDistance,
        shortAxisDistance
      } = data.defaultParam[0];
      this.ruleForm.maxSlope = maxSlope;
      this.ruleForm.maxWspd = maxWspd;
      this.ruleForm.boundaryDistance = boundaryDistance;
      this.ruleForm.wspd = wspd;
      //this.ruleForm.longAxisAngle = longAxisAngle;
      this.ruleForm.longAxisDistance = longAxisDistance;
      this.ruleForm.shortAxisDistance = shortAxisDistance;
      this.ruleForm.landOrSea = landOrSea;
    },
    async save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          await this.$postForm({
            url: '/manage/station/saveWindfarmPlanDefaultCondition',
            module: 'manage',
            data: this.ruleForm,
            showLoading: true,
            showError: true,
            showSuccess: true
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input__inner {
  width: 200px;
}
</style>
